import React, { useContext, useEffect } from 'react'
import Space from '../atoms/Space'
import { View } from '../other/html'
import ListLeftColumn from './item/ListLeftColumn'
import { ItemContext, ItemDispatchContext } from 'src/contexts/itemContext'
import InvoiceRightColumn from './item/InvoiceRightColumn'

const InvoiceItem = (): JSX.Element => {
  const itemContext = useContext(ItemContext)
  const dispatchItemContext = useContext(ItemDispatchContext)
  if (itemContext === null || dispatchItemContext === null) {
    throw new Error('itemContext must be used within a ItemProvider')
  }
  useEffect(() => {
    dispatchItemContext({ type: 'SET_BAR', payload: 'pick_up' })
  }, [dispatchItemContext])

  const { index } = itemContext
  const backgroundColor = (i: number): string => (i % 2 === 0 ? 'bg-lightGrey' : 'bg-white')
  const radiusStyles = 'rounded-2'
  const cursorStyles = 'cursor-pointer'
  return (
    <View
      className={`shadow-bothSmall  mb-4 ${backgroundColor(index)} ${radiusStyles} ${cursorStyles}`}
      onClick={() => {
        window.open(itemContext.file_url, '_blank')
      }}>
      <Space y={2} />
      <View className="flex justify-between">
        <ListLeftColumn showOfferHashId={true} showDealersIcon={false} showEyeIcon={false} showLikeIcon={false} />
        <InvoiceRightColumn />
      </View>
      <Space y={2} />
    </View>
  )
}

export default React.memo(InvoiceItem)
